import { BackButton } from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { useRecipientDeliveryContext } from '@/src/common/contexts/RecipientDeliveryContext'
import { clearAllAddressFields } from '@/src/common/utilities/clearAllAddressFields'
import DefaultAddressForm from '@/src/modules/checkout/forms/DefaultAddressForm'
import NameInput from '@/src/common/components/elements/Inputs/NameInput'

export const ManualAddressForm = () => {
    const {
        name,
        setName,
        state,
        setState,
        zip,
        setZip,
        formErrors,
        setFormErrors,
        setSearchManually,
        addressFullWidthFields,
    } = useRecipientDeliveryContext()
    return (
        <>
            <BackButton
                marginBottom={'manual-form'}
                onClick={() => {
                    clearAllAddressFields({
                        fullWidthFields: addressFullWidthFields,
                        setState: setState,
                        setZip: setZip,
                    })
                    setSearchManually(false)
                }}
            >
                <FontAwesomeIcon
                    icon={faArrowLeft}
                    style={{ marginRight: '0.5rem' }}
                />
                &nbsp;Back
            </BackButton>
            <NameInput
                name={name}
                setName={setName}
                formErrors={formErrors}
                setFormErrors={setFormErrors}
                fieldId={'name'}
            />
            <DefaultAddressForm
                fullWidthFields={addressFullWidthFields}
                state={state}
                zip={zip}
                formErrors={formErrors}
                setState={setState}
                setZip={setZip}
                setFormErrors={setFormErrors}
            />
        </>
    )
}
